// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"ListC_TheComp__oeV5N"};